module.exports = __webpack_public_path__ + "static/media/searchHeader.db9cf271.svg";